import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


export const getAboutUsPage = createAsyncThunk(
  "aboutus/page",
  async (_, { rejectWithValue }) => {
    try {
      return await GET(API.GET_ABOUTUS_PAGE);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const emptyPage = {
  sections: [],
  journey: [],
  team: [],
  gallery: [],
  reviews: [],
  impact: [],
  brands: [],
};

const aboutusSlice = createSlice({
  name: "aboutus",
  initialState: { page: emptyPage, error: null, status: "idle" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAboutUsPage.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAboutUsPage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.page = { ...emptyPage, ...(action.payload?.data || {}) };
      })
      .addCase(getAboutUsPage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default aboutusSlice.reducer;